import { render, staticRenderFns } from "./Titulo2.vue?vue&type=template&id=09209eaa&scoped=true&"
import script from "./Titulo2.vue?vue&type=script&lang=js&"
export * from "./Titulo2.vue?vue&type=script&lang=js&"
import style0 from "./Titulo2.vue?vue&type=style&index=0&id=09209eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09209eaa",
  null
  
)

export default component.exports